import { Link } from 'react-router-dom';

import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPenAlt, faPhone } from '@fortawesome/free-solid-svg-icons';

function PhoneCard(prop) {
 const { phones: { idpho, phonenumber, contactid }, changeVisibityMessages, setPhoneModify, setIidModPhone, del, handleClickToCall } = prop;

  return (
    <div name= {phonenumber } id={ phonenumber } className="card field mt-2 column is-offset-two-quarter is-half has-text-centered mx-1">
      <header className="card-header has-text-centered">
        <p className="card-header-title has-text-centered">
          { phonenumber &&  Number(phonenumber.split('')[0]) === 8 ? '0' + phonenumber : phonenumber }
        </p>
        <button className="card-header-icon" aria-label="more options" onClick={ () => handleClickToCall(phonenumber) }>
          <span className="icon">
            <FontAwesomeIcon icon={ faPhone } fixedWidth />
          </span>
        </button>
      </header>
      <footer className="card-footer">
      </footer>
    </div>
  )
}

export default PhoneCard;
